import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import PowerSettingsIcon from '@material-ui/icons/PowerSettingsNew';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from './Divider';

const propTypes = {
  onClick: PropTypes.func.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    whiteSpace: 'nowrap',
  },
  icon: {
    minWidth: 40,
  },
  chevron: {
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  chevronRight: {
    transform: 'rotate(-180deg)',
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

function Footer(props) {
  const { onClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <Divider />
      <ListItem classes={{ root: classes.root }} button onClick={onClick}>
        <ListItemIcon classes={{ root: classes.icon }}>
          <PowerSettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Cerrar sesión" />
      </ListItem>
      <Divider />
    </Fragment>
  );
}

Footer.propTypes = propTypes;

export default Footer;
